export enum ItemEventType {
    ADDED = 'ADDED',
    CHANGED = 'CHANGED',
    REMOVED = 'REMOVED'
}

export class ItemEvent<T> {
    constructor(readonly type: ItemEventType,
                readonly item: T) {
    }

    static added<T>(item: T): ItemEvent<T> {
        return new ItemEvent<T>(ItemEventType.ADDED, item)
    }

    static changed<T>(item: T): ItemEvent<T> {
        return new ItemEvent<T>(ItemEventType.CHANGED, item)
    }

    static removed<T>(item: T): ItemEvent<T> {
        return new ItemEvent<T>(ItemEventType.REMOVED, item)
    }
}